import { render, staticRenderFns } from "./FinanceAndDubanPdf.vue?vue&type=template&id=bfd3049e&scoped=true"
import script from "./FinanceAndDubanPdf.vue?vue&type=script&lang=js"
export * from "./FinanceAndDubanPdf.vue?vue&type=script&lang=js"
import style0 from "./FinanceAndDubanPdf.vue?vue&type=style&index=0&id=bfd3049e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd3049e",
  null
  
)

export default component.exports